<template>
  <div class="row">
    <div class="form-group col-md-4">
      <label v-if="!question.is_list">First Name</label>
      <input
        v-model="value.first_name"
        class="form-control"
        @focus="focus"
        @blur="save"
      >
    </div>
    <div class="form-group col-md-4">
      <label v-if="!question.is_list">Middle Name</label>
      <input
        v-model="value.middle_name"
        class="form-control"
        @focus="focus"
        @blur="save"
      >
    </div>
    <div class="form-group col-md-4">
      <label v-if="!question.is_list">Last Name</label>
      <input
        v-model="value.last_name"
        class="form-control"
        @focus="focus"
        @blur="save"
      >
    </div>
  </div>
</template>

<script>
import answerMixin from './answermixin'

export default {
  name: 'NameAnswer',
  mixins: [answerMixin],
  props: [ 'isClient' ],
  data () {
    return {
      value: {
        first_name: '',
        middle_name: '',
        last_name: ''
      },
      savedValue: {
        first_name: '',
        middle_name: '',
        last_name: ''
      }
    }
  },
  beforeMount () {
    this.value = {
      first_name: this.answer.first_name || '',
      middle_name: this.answer.middle_name || '',
      last_name: this.answer.last_name || ''
    }
  },
  computed: {
    valueChanged () {
      return (
        this.value.first_name !== this.savedValue.first_name ||
        this.value.middle_name !== this.savedValue.middle_name ||
        this.value.last_name !== this.savedValue.last_name
      )
    }
  },
  methods: {
    focus () {
      this.savedValue = JSON.parse(JSON.stringify(this.value))
    }
  }
}
</script>
